var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1878 17.1901H7.65413L7.16736 15.0494C6.58805 14.828 6.04628 14.5225 5.5604 14.143L3.41896 14.8016L1.6521 11.8115L3.30588 10.3285C3.21333 9.7276 3.21333 9.11659 3.30588 8.51573L1.6521 7.03187L3.41896 4.04171L5.5604 4.70034C6.0465 4.3205 6.58857 4.01463 7.16824 3.7931L7.65413 1.65234H11.1878L11.6746 3.7931C12.2539 4.01445 12.7957 4.32002 13.2816 4.69947L15.423 4.04085L17.1899 7.031L15.5361 8.514C15.6287 9.11486 15.6287 9.72588 15.5361 10.3267L17.1899 11.8097L15.423 14.7999L13.2816 14.1413C12.7958 14.5214 12.254 14.8275 11.6746 15.0494L11.1878 17.1901Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42139 12.3345C11.0304 12.3345 12.3347 11.0301 12.3347 9.42115C12.3347 7.81216 11.0304 6.50781 9.42139 6.50781C7.8124 6.50781 6.50806 7.81216 6.50806 9.42115C6.50806 11.0301 7.8124 12.3345 9.42139 12.3345Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.c67ff1b4c0baab2b27fff4928513d5b8.svg";
export { ForwardRef as ReactComponent };